module.exports = __webpack_public_path__ + "img/r2_type.0fb765ac.png";